export const discardDraftCopy = {
  header: '',
  description: '',
  confirmBtnText: '',
};
